import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a2498992&scoped=true&"
import script from "./SeniorSetting.js?vue&type=script&lang=js&"
export * from "./SeniorSetting.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a2498992&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2498992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2498992')) {
      api.createRecord('a2498992', component.options)
    } else {
      api.reload('a2498992', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a2498992&scoped=true&", function () {
      api.rerender('a2498992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MesTable/SeniorSetting/index.vue"
export default component.exports